import { createFileRoute } from "@tanstack/react-router";
import type { FermentationGroupId } from "@brewbase/db/types";
import { DataSection } from "@/features/fermentation-journal/components/results/data-section";

export const Route = createFileRoute("/fermentations/$group_id/results/data")({
  component: DataPage,
});

function DataPage() {
  const { group_id } = Route.useParams();
  const groupId = Number(group_id) as FermentationGroupId;

  return (
    <div className="absolute inset-0 flex flex-col">
      <DataSection groupId={groupId} />
    </div>
  );
}
